import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Masonry from '@mui/lab/Masonry'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { GetReportDetailsFragmentFragment } from 'gqlTypes'
import ReportOverviewActions from './ReportOverviewActions'
import {
  CurrentTenantContext,
  useCurrentUserContext,
} from '../../contexts/CurrentUserContext'
import StarIcon from '@mui/icons-material/Star'

interface Props {
  report: GetReportDetailsFragmentFragment
}
const ReportOverview: React.FC<Props> = ({ report }) => {
  const currentUser = useCurrentUserContext()

  const rootSections = (report.sections || []).filter(
    (s) => s.parentReportSectionId === null
  )

  const tenant = useContext(CurrentTenantContext)

  return (
    <Box sx={{ m: 4, width: '100%' }}>
      <Paper sx={{ mb: 2, p: 4 }}>
        <Typography variant="body2" sx={{ mb: 4, color: 'grey.700' }}>
          {[report.publishedYear, report.reportType]
            .filter((x) => x)
            .join(' - ')}
        </Typography>
        <Typography sx={{ color: 'secondary.main', fontWeight: 'bold' }}>
          Report Overview
        </Typography>
        <Typography
          variant="h1"
          sx={{ my: 1, color: 'primary.main', fontWeight: 'bold' }}
        >
          {report.title ?? '(No Title)'}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            endIcon={<ArrowForwardIcon />}
            component={Link}
            disabled={!rootSections.length}
            to={`/reports/${report.id}/sections/${rootSections[0]?.id}`}
          >
            Start Reading
          </Button>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<StarIcon />}
            component={Link}
            disabled={!rootSections.length}
            to={`/report_bookmarks/${report.id}/sections/${rootSections[0]?.id}`}
          >
            View Bookmarks
          </Button>
        </Box>
      </Paper>
      <Masonry columns={2} spacing={2} sx={{ width: 'auto' }}>
        <ReportOverviewActions tenant={tenant} report={report} />
        <Paper sx={{ px: 4, py: 2 }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Support
          </Typography>
          <Typography variant="h6">Need help right now?</Typography>
          <Box>
            {tenant && (
              <>
                <Typography>{`Reach out to your main contact at ${tenant.title}`}</Typography>
                {tenant.help_link && (
                  <a href={tenant.help_link}>
                    {tenant.help_link_text || tenant.help_link}
                  </a>
                )}
                <Typography>{tenant.phone}</Typography>
              </>
            )}
          </Box>
          {tenant?.body_class === 'youthtruth_subdomain' && (
            <>
              <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                Help Documents
              </Typography>
              <a
                href="https://youthtruth.org/backpack/?password=backpack"
                target="_blank"
              >
                Backpack
              </a>
            </>
          )}
        </Paper>
      </Masonry>
    </Box>
  )
}

export default ReportOverview
